import { IconCollapse, IconExpand } from '@ui/src';
import { RiskScoringContentTypes, RiskScoringTypes } from '../types';
import ExpandableRow from './expandable-row';
import ExpandableRowContent from './expandable-row-content';
import { OrganizationType } from '../../../../hoc/common/types';
import DateOfIncorporation from './date-of-incorporation';

import cn from '../styles.module.css';

const RiskScoringContent = ({
  blockCollapsed,
  onExpandClick,
  expandedRows,
  type,
  setExpandedRows,
  aml,
  countries,
  clientsActivities,
  deliveryChannels,
  products,
  sourcesOfFunds,
  sicCodesDictionaries,
  monthlyTurnover,
  riskScoreRanges,
}: RiskScoringContentTypes) => (
  <>
    {blockCollapsed && (
      <>
        <div className={cn.collapseButtonWrapper}>
          <button
            type="button"
            className={cn.collapseAllButton}
            onClick={onExpandClick}
          >
            {!expandedRows?.length ? 'Expand all' : 'Collapse all'}
            {!expandedRows?.length ? (
              <IconExpand width={15} height={15} className={cn.iconExpand} />
            ) : (
              <IconCollapse width={15} className={cn.iconCollapse} />
            )}
          </button>
        </div>
        <ExpandableRow
          name={RiskScoringTypes.GEOGRAPHICAL_RISK}
          title="Geographical risk"
          expandedRows={expandedRows}
          setExpandedRows={setExpandedRows}
          totalRisk={aml?.geographicalRiskTotal as number}
          riskScoreRanges={riskScoreRanges}
        >
          {type === OrganizationType.INDIVIDUAL && (
            <>
              <ExpandableRowContent
                title="Residency:"
                value={aml?.countryId as string}
                risk={
                  aml?.countryRisk?.toString() !== 'null' &&
                  aml?.countryRisk?.toString() !== 'undefined'
                    ? (aml?.countryRisk?.toString() as string)
                    : '-'
                }
                list={countries}
                name="residency"
              />
              <ExpandableRowContent
                title="Citizenship:"
                value={aml?.nationalityId as string}
                risk={
                  aml?.nationalityRisk?.toString() !== 'null' &&
                  aml?.nationalityRisk?.toString() !== 'undefined'
                    ? (aml?.nationalityRisk?.toString() as string)
                    : '-'
                }
                list={countries}
                name="citizenship"
              />
            </>
          )}
          {type === OrganizationType.CORPORATE && (
            <>
              <ExpandableRowContent
                title="Country of incorporation:"
                value={aml?.countryOfIncorporationId as string}
                risk={
                  aml?.countryOfIncorporationRisk?.toString() !== 'null' &&
                  aml?.countryOfIncorporationRisk?.toString() !== 'undefined'
                    ? (aml?.countryOfIncorporationRisk?.toString() as string)
                    : '-'
                }
                list={countries}
                name="countryOfIncorporation"
              />
              <ExpandableRowContent
                title="Citizenship of company officials"
                value=""
                risk={
                  aml?.officialRiskTotal?.toString() !== 'null' &&
                  aml?.officialRiskTotal?.toString() !== 'undefined'
                    ? (aml?.officialRiskTotal?.toString() as string)
                    : '-'
                }
                list={countries}
                name="citizenshipOfCompanyOfficials"
                officialRiskItems={aml?.officialRiskItems}
                withoutOpacity
              />
              {/* <ExpandableRowContent
              title="Relevant countries"
              value={aml?.countryId as string}
              risk={aml?.countryRisk as number}
              name="relevantCountries"
              list={countries}
              isEditable={isEditable}
            /> */}
            </>
          )}
        </ExpandableRow>
        {type === OrganizationType.INDIVIDUAL && (
          <ExpandableRow
            name={RiskScoringTypes.TYPE_OF_CLIENT}
            title="Type of client"
            expandedRows={expandedRows}
            setExpandedRows={setExpandedRows}
            totalRisk={aml?.clientActivityRisk as number}
            riskScoreRanges={riskScoreRanges}
          >
            <ExpandableRowContent
              title="Activity of the client:"
              value={aml?.clientActivityId as string}
              risk={
                aml?.clientActivityRisk?.toString() !== 'null' &&
                aml?.clientActivityRisk?.toString() !== 'undefined'
                  ? (aml?.clientActivityRisk?.toString() as string)
                  : '-'
              }
              list={clientsActivities}
              name="privateIndividual"
            />
          </ExpandableRow>
        )}
        <ExpandableRow
          name={RiskScoringTypes.DELIVERY_CHANNEL}
          title="Delivery channel"
          expandedRows={expandedRows}
          setExpandedRows={setExpandedRows}
          totalRisk={aml?.deliveryChannelRisk as number}
          riskScoreRanges={riskScoreRanges}
        >
          <ExpandableRowContent
            value={aml?.deliveryChannelId as string}
            risk={
              aml?.deliveryChannelRisk?.toString() !== 'null' &&
              aml?.deliveryChannelRisk?.toString() !== 'undefined'
                ? (aml?.deliveryChannelRisk?.toString() as string)
                : '-'
            }
            list={deliveryChannels}
            name="channel"
          />
        </ExpandableRow>
        <ExpandableRow
          name={RiskScoringTypes.PRODUCTS}
          title="Products"
          expandedRows={expandedRows}
          setExpandedRows={setExpandedRows}
          totalRisk={aml?.productsRiskTotal as number}
          riskScoreRanges={riskScoreRanges}
        >
          {aml?.productsRiskItems?.map((item) => (
            <ExpandableRowContent
              key={item.id}
              value={
                products?.find((product) => product.value === item.id)
                  ?.name as string
              }
              risk={
                item.value?.toString() !== 'null' &&
                item.value?.toString() !== 'undefined'
                  ? item.value?.toString()
                  : '-'
              }
              name={
                products?.find((product) => product.value === item.id)?.name
              }
            />
          ))}
        </ExpandableRow>
        {type === OrganizationType.INDIVIDUAL && (
          <ExpandableRow
            name={RiskScoringTypes.SOURCE_OF_FUNDS}
            title="Source of Funds"
            expandedRows={expandedRows}
            setExpandedRows={setExpandedRows}
            totalRisk={aml?.sourcesOfFundsRiskTotal as number}
            riskScoreRanges={riskScoreRanges}
          >
            {aml?.sourcesOfFundsRiskItems?.map((item) => (
              <ExpandableRowContent
                key={item.id}
                value={
                  sourcesOfFunds?.find((source) => source.value === item.id)
                    ?.name as string
                }
                risk={
                  item.value?.toString() !== 'null' &&
                  item.value?.toString() !== 'undefined'
                    ? item.value?.toString()
                    : '-'
                }
                name={
                  sourcesOfFunds?.find((source) => source.value === item.id)
                    ?.name
                }
              />
            ))}
          </ExpandableRow>
        )}
        {type === OrganizationType.CORPORATE && (
          <>
            <DateOfIncorporation
              expandedRows={expandedRows}
              setExpandedRows={setExpandedRows}
              riskScoreRanges={riskScoreRanges}
              values={aml}
            />
            <ExpandableRow
              name={RiskScoringTypes.SIC_CODES}
              title="Sic Codes"
              expandedRows={expandedRows}
              setExpandedRows={setExpandedRows}
              totalRisk={aml?.sicRiskTotal as number}
              riskScoreRanges={riskScoreRanges}
            >
              {aml?.sicRiskItems?.map((item) => (
                <ExpandableRowContent
                  key={item.name}
                  value={`${
                    sicCodesDictionaries?.find(
                      (sicCode) => sicCode.name === item.name,
                    )?.name as string
                  } - ${
                    sicCodesDictionaries?.find(
                      (sicCode) => sicCode.name === item.name,
                    )?.description as string
                  }
          `}
                  risk={
                    item.value?.toString() !== 'null' &&
                    item.value?.toString() !== 'undefined'
                      ? item.value?.toString()
                      : '-'
                  }
                  name={
                    sicCodesDictionaries?.find(
                      (sicCode) => sicCode.name === item.name,
                    )?.name
                  }
                />
              ))}
            </ExpandableRow>
          </>
        )}
        <ExpandableRow
          name={RiskScoringTypes.MONTHLY_VOLUMES}
          title="Turnover"
          expandedRows={expandedRows}
          setExpandedRows={setExpandedRows}
          totalRisk={aml?.monthlyTurnoverRangeRisk as number}
          riskScoreRanges={riskScoreRanges}
        >
          <ExpandableRowContent
            title="Turnover:"
            value={aml?.monthlyTurnoverRangeId as string}
            risk={
              aml?.monthlyTurnoverRangeRisk?.toString() !== 'null' &&
              aml?.monthlyTurnoverRangeRisk?.toString() !== 'undefined'
                ? (aml?.monthlyTurnoverRangeRisk?.toString() as string)
                : '-'
            }
            list={monthlyTurnover}
            name="monthlyTurnoverRangeId"
          />
        </ExpandableRow>
      </>
    )}
  </>
);

export default RiskScoringContent;
